<div #widgetRoot class="booking-widget relative" [innerHTML]="widgetPlaceholder | finSafe: 'html'"></div>
